<template>
  <v-app style="max-width: 1440px; margin: auto;">
    <v-content>
      <header-block :username="username" @setAnalytics="setAnalytics($event)" @callLogout="callLogout" />
      <login-form ref="usermanager" v-show="!username" @onLogin="onLogin($event)" @onLogout="onLogout" />
      <analytics-block v-if="username" :showAnalytics="showAnalytics" @showEventDetails="setShowEventDetails" />
      <event-details :eventItem="eventItem" />
      <footer-block/>
    </v-content>
  </v-app>
</template>

<script>

import LoginForm from './LoginForm';
import Analytics from './Analytics';
import EventDetails from './EventDetails';
import Header from './Header';
import Footer from './Footer';

export default {
  name: 'Admin',

  components: {
    'login-form': LoginForm,
    'analytics-block': Analytics,
    'event-details': EventDetails,
    'header-block': Header,
    'footer-block': Footer,
  },

  data: () => ({
      loggedIn: false,
      username: '',
      showAnalytics: 'events',
      eventItem: '',
  }),

  methods: {
      onLogin(username) {
          this.loggedIn = true;
        this.username = username;
      },
      onLogout() {
          this.loggedIn = false;
        this.username = '';
      },
      callLogout() {
          console.log("logout called");
          this.$refs.usermanager.logout();
      },
      setAnalytics(name) {
        this.showAnalytics = name;
      },
      setShowJob(jobId) {
        console.log("ShowJob: " + jobId);
        this.jobId = jobId;
      },
      setShowEventDetails(eventItem) {
        console.log("ShoweventItem: " + eventItem);
        console.log(eventItem);
        this.eventItem = eventItem;
      },

  },
  mounted() {
    
  }

};
</script>